import styled from "styled-components";
import { scroller } from "react-scroll";

const Button = ({ text, width, func }) => {
  return (
    <Wrapper width={width} onClick={func}>
      {text}
    </Wrapper>
  );
};

const Wrapper = styled.button`
  font-size: 1.6rem;
  background-color: var(--main-color);
  cursor: pointer;
  padding: 12px 24px;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.width ? props.width : "100%")};
  transition: ease-in-out 0.2s;
  -webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  :hover {
    background: var(--third-color-highlight);
  }
`;

export default Button;
